export default [{
	titulo: 'Minha Conta',
	icone: 'menu-icon fa fa-caret-right',
	url: '/inicio/minha-conta',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Editar'
	}]
}]